export default "__VITE_ASSET__4dcLcaXz__"